<!-- 自定义Input_num计数器组件 -->
<!-- 返回参数以及接受参数类型为String，若为Number类型，则watch监听存在获取类型错误异常信息 -->

<template>
  <div class="input_num" :class="useFul ? 'disbale_div' : 'able_div'">
    <div class="input_num_body">
      <el-button
        circle
        @click="minus"
        class="minus_button"
        :class="useFul ? 'disbale_div' : 'able_div'"
      >
      </el-button>
      <el-input
        :disabled="useFul"
        v-model.number="counter_num"
        :maxlength="maxLength"
        v-on:input="changeInputFunc"
      />
      <el-button
        :class="useFul ? 'disbale_div' : 'able_div'"
        circle
        @click="add"
        class="add_button"
      >
      </el-button>
    </div>
    <span class="sp_unit">pt</span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sp_add_icon: require("@/assets/icon/sp-icon-input-add.svg"),
      sp_minus_icon: require("@/assets/icon/sp-icon-input-minus.svg"),
      counter_num: this.value == "" ? 0 : this.value, // 计数
      maxLength: this.length,
      // counter_num:'',// 使用此行写法需要对vlaue属性添加监听，且调用出需要使用:value传值
      min_num: 0, // 最小值
      max_num: 99999999, // 最大值
      step_num: 1000,
    };
  },
  props: {
    value: {
      type: Number,
      default: 0,
    },
    length: {
      type: Number,
      default: 10,
    },
    useFul: {
      type: Boolean,
      default: false,
    },
  },
  methods: {

    /**
     * input change event
     */
    changeInputFunc(val){
      // oninput="value=value.replace(/[^\d]/g,'')"
      if ('' == val){
        this.counter_num = 0;
      }
      let numReg = /^[0-9]+$/;
      let numExp = new RegExp(numReg);
      if(!numExp.test(val)){
        this.counter_num = val.replace(/[^\d]/g,'');
      }
    },
    /**
     * 减号事件
     */
    minus() {
      if (this.useFul) {
        return;
      }
      if ("" == this.counter_num) {
        this.counter_num = 0;
      }
      let counter_num_int = parseInt(this.counter_num);
      // let min_num_int = parseInt(this.min_num);
      if (counter_num_int <= this.step_num) {
        this.counter_num = this.min_num;
      } else {
        this.counter_num = counter_num_int - 1000;
      }
    },
    /**
     * 加号事件
     */
    add() {
      if (this.useFul) {
        return;
      }
      if ("" == this.counter_num) {
        this.counter_num = 0;
      }

      let countLength =
        "" == this.counter_num ? 0 : this.counter_num.toString();

      if (countLength.length >= parseInt(this.length)) {
        return;
      } else {
        this.counter_num = this.counter_num + 1000;
      }
      // let counter_num_int = parseInt(this.counter_num);
      // let max_num_int = parseInt(this.max_num);
      // if (counter_num_int >= max_num_int) {
      //   this.counter_num = this.max_num;
      // } else {
      //   this.counter_num = counter_num_int + 1000;
      // }
    },
  },
  watch: {
    counter_num(newVal, oldVal) {
      // oninput="value=value.replace(/[^\d]/g,'')"
      // let numReg = /^[0-9]+$/;
      // let numExp = new RegExp(numReg);
      if (newVal != oldVal) {
        this.$emit("in_put", newVal);
      }
    },
    /**
     * 传入值监听
     */
    value: {
      deep: true,
      handler(val) {
        if (val == null) {
          val = 0;
        }
        if ("" == val) {
          val = 0;
        }
        this.counter_num = val;
      },
    },
    length: {
      deep: true,
      handler(val) {
        this.maxLength = val;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.add_button {
  height: 36px;
  width: 40px;
  border: none;
  background: url("../../../assets/icon/sp-btn-add.png") no-repeat;
  background-size: 100%;
}

.add_button:hover {
  opacity: 0.6;
  height: 36px;
  width: 40px;
  border: none;
  background: url("../../../assets/icon/sp-btn-add.png") no-repeat;
  background-size: 100%;
}

.minus_button {
  margin-left: 5px;
  height: 36px;
  width: 40px;
  border: none;
  background: url("../../../assets/icon/sp-btn-minus.png") no-repeat;
  background-size: 100%;
}

.minus_button:hover {
  opacity: 0.6;
  margin-left: 5px;
  height: 36px;
  width: 40px;
  border: none;
  background: url("../../../assets/icon/sp-btn-minus.png") no-repeat;
  background-size: 100%;
}

.sp_unit {
  float: left;
  color: #525250;
  height: 30px;
  width: 27px;
  text-align: center;
  font-size: 14px;
  padding-top: 3px;
  padding-left: 5px;
}
.input_num_body {
  // box-shadow:1px 2px 3px 4px #f2f2ed inset;
  line-height: 10px;
  float: left;
  width: 200px;
  height: 44px;
  display: flex;
  align-items: center;
  border-radius: 25px;
  background-color: #f2f2ed;
  box-shadow: -2px -2px 4px #ffffff inset, -2px -2px 4px #ffffff inset, 2px 2px 4px #e6e6d8 inset, 2px 2px 4px #e6e6d8 inset !important;
}
::v-deep .el-input {
  width: 136px !important;
  height: 40px !important;
  box-shadow: none;
  outline: none;
  text-align: center;
  color: #525250;
  font-size: 15px;

  .el-input__inner {
    width: 100%;
    background-color: transparent;
    box-shadow: none;
    text-align: center;
  }
}
.input_num {
  width: 227px;
  height: 44px;
}
.able_div {
}
.disbale_div {
  cursor: not-allowed;
}

::v-deep .el-input__inner {
  box-shadow: none !important;
}
</style>
